import { render, staticRenderFns } from "./Instance.vue?vue&type=template&id=28de1f2b&scoped=true&"
import script from "./Instance.vue?vue&type=script&lang=js&"
export * from "./Instance.vue?vue&type=script&lang=js&"
import style0 from "./Instance.vue?vue&type=style&index=0&id=28de1f2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28de1f2b",
  null
  
)

export default component.exports